<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">

        <div class="mis-xv-wrapper-fixed">
          <img
            src="@/assets/corona.png"
            class="ornamento-img floating"
          >
          <div
            ref="misXvTopRef"
            class="mis-xv-top glowing"
          >
            Sweet 16
          </div>
        </div>

        <!-- Nombasassasasaasasasre -->
        <div
          ref="nombreRef"
          class="centered-text"
        >
     <br> 
     <span class="apellido-british">Nicole</span>
<br><br>

          <div
            ref="fechaRef"
            class="fecha-evento"
          >
            <span class="fecha-dia"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-mes"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-anio"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null);
    const nombreRef = ref(null);
    const fechaRef = ref(null);
    const misXvRef = ref(null);
    const misXvTopRef = ref(null);

    onMounted(() => {
      gsap.from(fotoPortadaRef.value, {
        opacity: 0,
        y: 100,
        duration: 1.5,
        ease: 'power3.out'
      });

      gsap.from(misXvTopRef.value, {
        opacity: 0,
        y: -20,
        duration: 1.2,
        delay: 0.5,
        ease: 'power3.out'
      });

      gsap.from(nombreRef.value, {
        opacity: 0,
        y: -30,
        duration: 1.3,
        ease: 'back.out(1.7)',
        delay: 1
      });

      gsap.to(fechaRef.value.children, {
  opacity: 1,
  y: 0,
  duration: 1,
  stagger: 0.2,
  ease: 'power3.out',
  delay: 1.6
});


      gsap.from(misXvRef.value, {
        opacity: 0,
        y: 40,
        scale: 0.9,
        duration: 1.3,
        ease: 'back.out(1.7)',
        delay: 3.2
      });
    });

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      misXvRef,
      misXvTopRef
    };
  }
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  margin-top: -65px;
  background-image: 
    linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.331)), 
    url('@/assets/NICOLE.NATURAL5.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;

  /* Efecto de luz sutil */
  box-shadow: 0 -40px 80px rgba(255, 255, 255, 0.2) inset,
              0 20px 40px rgba(0, 0, 0, 0.3);
}


.overlay {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;
}

/* MIS XV en esquina superior izquierda */
.mis-xv-wrapper-fixed {
  position: absolute;
  top: -25px;
  left: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.ornamento-img {
  width: 40px;
  height: auto;
  opacity: 1;
  filter: brightness(0) invert(1);
  margin-bottom: 4px;
}

.mis-xv-top {
  font-family: 'file';
  font-size: 20px;
  letter-spacing: 1px;
  color: white;
  text-align: center;
}



.glowing {
  animation: glow 2.5s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    text-shadow: 0 0 5px rgba(255,255,255,0.3);
  }
  to {
    text-shadow: 0 0 15px rgba(255,255,255,0.9);
  }
}
.centered-text {
  font-size: 45px;
  font-weight: 500;
  text-align: center;
  padding-top: 240px;
  padding-bottom: 20px;
  line-height: 1;
  padding-left: 40px;
  padding-right: 40px;

  font-family: 'nombre' !important;
  background: rgb(253, 253, 253);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;


  white-space: nowrap;
  overflow: visible;
}

.fecha-evento {
  font-family: 'Karla', sans-serif;
  color: white;
  font-size: 18px;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-shadow: 0 0 6px rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  transform-origin: center;
}

.fecha-evento span {
  opacity: 0;
  transform: translateY(20px);
}


.mis-xv-text {
  font-family: 'Daydream', cursive;
  font-size: 30px;
  color: #f8a4cf;
  text-align: right;
  width: 90%;
  margin-top: -10px;
  margin-bottom: -50px;
  letter-spacing: 2px;
  position: absolute;
  right: 5%;
  bottom: 60px;
  z-index: 3;
}

.separador-container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  height: 80px;
  margin-top: -15px;
  margin-bottom: 30px;
}

.separador-img2 {
  width: 100%;
  height: auto;
  z-index: 2;
}

.apellido-british{
  font-family: 'british', cursive !important;
  font-size: 49px;
  letter-spacing: 2px;
  display: inline-block;
margin-top:20px;
  background: linear-gradient(90deg, #ffffff, #e0e0e0, #ffffff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  line-height:3.1;


  transform: scale(1.05);
}
</style>
